// @ts-nocheck
import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Permission-aware action icons: View / Edit / Delete / Approve / Reject / custom.
 * Pass boolean flags from can('module.action').
 */
export default function ActionButtons({
    viewTo,
    onView,
    onEdit,
    onDelete,
    onApprove,
    onReject,
    canView = true,
    canEdit = false,
    canDelete = false,
    canApprove = false,
    size = 'sm',
    className = '',
    deleteTitle = 'Delete',
    approveTitle = 'Approve',
    rejectTitle = 'Reject',
    extra = null,
}) {
    const btn = `btn btn-outline-secondary btn-${size}`;
    const hasAny =
        (canView && (viewTo || onView)) ||
        (canEdit && onEdit) ||
        (canDelete && onDelete) ||
        (canApprove && (onApprove || onReject)) ||
        extra;

    if (!hasAny) return <span className="text-muted small">—</span>;

    return (
        <div className={`btn-group btn-group-${size} ${className}`} role="group">
            {canView && viewTo && (
                <Link to={viewTo} className={btn} title="View">
                    <i className="bi bi-eye" />
                </Link>
            )}
            {canView && !viewTo && onView && (
                <button type="button" className={btn} title="View" onClick={onView}>
                    <i className="bi bi-eye" />
                </button>
            )}
            {canEdit && onEdit && (
                <button type="button" className={`${btn} btn-outline-primary`} title="Edit" onClick={onEdit}>
                    <i className="bi bi-pencil" />
                </button>
            )}
            {canApprove && onApprove && (
                <button type="button" className="btn btn-outline-success btn-sm" title={approveTitle} onClick={onApprove}>
                    <i className="bi bi-check2" />
                </button>
            )}
            {canApprove && onReject && (
                <button type="button" className="btn btn-outline-warning btn-sm" title={rejectTitle} onClick={onReject}>
                    <i className="bi bi-x-lg" />
                </button>
            )}
            {canDelete && onDelete && (
                <button type="button" className="btn btn-outline-danger btn-sm" title={deleteTitle} onClick={onDelete}>
                    <i className="bi bi-trash" />
                </button>
            )}
            {extra}
        </div>
    );
}
